import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { ThemeService } from 'src/app/core/services/theme/theme.service';
import { TutorialWizardComponent } from '../tutorial-wizard.component';
import { TutorialWizardSlideDirective } from '../tutorial-wizard-slide.directive';
import { TutorialSlideContentComponent } from '../tutorial-slide-content/tutorial-slide-content.component';
import { TutorialVersusContentComponent } from '../tutorial-versus-content/tutorial-versus-content.component';
import { GameTutorial } from './game-tutorial';

@Component({
  selector: 'app-blocks-tutorial',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TutorialWizardComponent,
    TutorialWizardSlideDirective,
    TutorialSlideContentComponent,
    TutorialVersusContentComponent,
  ],
  template: `
    <app-tutorial-wizard [totalPages]="3" [slideTitles]="slideTitles">
      <div appTutorialSlide>
        <app-tutorial-slide-content
          [imageUrl]="img('blocks-tutorial-1.png')"
          [description]="t('blocks-slide-1')"
        />
      </div>

      <div appTutorialSlide>
        <app-tutorial-slide-content
          [imageUrl]="img('blocks-tutorial-2.png')"
          [description]="t('blocks-slide-2')"
        />
      </div>

      <div appTutorialSlide>
        <app-tutorial-versus-content
          [imageUrl]="img('blocks-tutorial-3.png')"
          [description]="t('blocks-slide-3')"
        />
      </div>
    </app-tutorial-wizard>
  `,
  styles: [],
})
export class BlocksTutorialComponent implements GameTutorial {
  private translocoService = inject(TranslocoService);
  private themeService = inject(ThemeService);

  readonly slideTitles = [this.t('how-to-play'), this.t('how-to-win'), this.t('real-opponents')];

  t(key: string): string {
    return this.translocoService.translate(`components.tutorial-wizard.${key}`);
  }

  img(name: string): string {
    return this.themeService.imageUrl(name);
  }
}
